import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type CorrectnessBreakdownResponse = {
  total: Total
  audited: Audited
  correctness: Correctness
  correctnessBreakdown: CorrectnessBreakdown[]
  exceedsMinResolutions: ExceedsMinResolutions
  program: { targetAccuracy: number }
}

type DefaultStats = {
  current: number
  previous: number
  trend: number
}

type Total = DefaultStats
type Audited = DefaultStats
type Correctness = DefaultStats
type ExceedsMinResolutions = DefaultStats

type CorrectnessBreakdown = {
  timeslice: string
  correct_count: number
  incorrect_count: number
  avg_accuracy: number
  correct_percentage: number
}
export const PLATFORM_MS_CORRECTNESS_BREAKDOWN_STATS_KEY = 'platform-ms-correctness-breakdown-stats'

export function useGetCorrectnessBreakdown(
  period: { start?: string; end?: string } | null,
  granularity?: 'daily' | 'monthly' | 'weekly',
  orgId?: string
) {
  return useQuery<CorrectnessBreakdownResponse>({
    queryKey: [PLATFORM_MS_CORRECTNESS_BREAKDOWN_STATS_KEY, period?.start, period?.end, granularity, orgId],
    enabled: Boolean(period?.start) && Boolean(period?.end) && Boolean(granularity),
    queryFn: async () => {
      const { data } = await apiClient.get(`/int/stats/platform/correctness-breakdown`, {
        params: {
          start_time: period?.start,
          end_time: period?.end,
          granularity: granularity,
          org_profile_id: orgId,
        },
      })
      return data
    },
  })
}
